import { ApiSuccessSchema } from "../../common/response.schema";
import {
  AccessCardCreateBodySchema,
  AccessCardDeletePathVarsSchema,
  AccessCardDeleteResponseSchema,
  AccessCardGetPathVarsSchema,
  AccessCardItemSchema,
  AccessCardListAllParamsSchema,
  AccessCardListAllResponseSchema,
  AccessCardListParamsSchema,
  AccessCardListResponseSchema,
  AccessCardUpdateBodySchema,
  AccessCardUpdatePathVarsSchema,
  AvailableActionsParamsSchema,
  AvailableActionsResponseSchema
} from "./schemas";

export const ZAccessCards = {
  AvailableActions: {
    method: "GET" as const,
    path: "/api/access-cards/available-actions",
    Params: AvailableActionsParamsSchema,
    Response: ApiSuccessSchema(AvailableActionsResponseSchema)
  },

  ListAll: {
    method: "GET" as const,
    path: "/api/access-cards/all",
    Params: AccessCardListAllParamsSchema,
    Response: ApiSuccessSchema(AccessCardListAllResponseSchema)
  },

  List: {
    method: "GET" as const,
    path: "/api/access-cards",
    Params: AccessCardListParamsSchema,
    Response: ApiSuccessSchema(AccessCardListResponseSchema)
  },

  Get: {
    method: "GET" as const,
    path: "/api/access-cards/:id",
    PathVars: AccessCardGetPathVarsSchema,
    Response: ApiSuccessSchema(AccessCardItemSchema)
  },

  Create: {
    method: "POST" as const,
    path: "/api/access-cards",
    Body: AccessCardCreateBodySchema,
    Response: ApiSuccessSchema(AccessCardItemSchema)
  },

  Update: {
    method: "PATCH" as const,
    path: "/api/access-cards/:id",
    PathVars: AccessCardUpdatePathVarsSchema,
    Body: AccessCardUpdateBodySchema,
    Response: ApiSuccessSchema(AccessCardItemSchema)
  },

  Delete: {
    method: "DELETE" as const,
    path: "/api/access-cards/:id",
    PathVars: AccessCardDeletePathVarsSchema,
    Response: ApiSuccessSchema(AccessCardDeleteResponseSchema)
  }
} as const;
